export default (caseNumber) => {
  return {
    name: "Upload Rebuttal Evidence",
    pageInfo: {
      text: "<i>Use this form to upload documents to your submitted application. Uploaded documents will be added to the case documents and directed to an analyst for review. Please check the correspondence issued for details on what is required for your case.</i>",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "fileType",
            value: "Rebuttal Evidence",
            widget: "text",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "Rebuttal_Evidence_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "Rebuttal_Evidence_Document_Upload" },
            accept_multiple: true,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
        ],
      },
    ],
  };
};
